import { scroller } from 'react-scroll'

export default function scrollTo(anchor: string) {
    scroller.scrollTo(anchor, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
    })
}
